import { connect } from 'react-redux'
import { selectInputMode } from '../selectors'

import AddTeamMembersFormView from './view'

const select = state => ({
  inputMode: selectInputMode(state),
})

export default connect(select)(AddTeamMembersFormView)
